import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { toast } from "react-toastify";

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import BasicLayout from "layouts/authentication/components/BasicLayout";

import apiClient from "api-client";

import { backgroundImage, tomarketLogo } from "assets/assets";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const handleForgotPassword = async (values, { setSubmitting }) => {
    try {
      await apiClient.post("auth/request-otp", {
        email: values.userEmail,
      });
      console.log("forgotPassword response", values.userEmail);
      setTimeout(() => {
        navigate(`/verify-otp?email=${encodeURIComponent(values.userEmail)}`);
      }, 1000);
      toast.success("Email Verification Code Sent");
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <BasicLayout image={backgroundImage} formType="forgot-password">
      <Card>
        <MDBox
          variant="gradient"
          bgColor="success"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <Grid item xs={12}>
            <MDBox
              component="img"
              sx={{
                zIndex: 100,
                width: "80%",
                maxWidth: "400px",
                height: "100px",
                objectFit: "contain",
                mt: "10px",
                mb: "auto",
                ml: "auto",
                mr: "auto",
              }}
              src={tomarketLogo}
              alt="Logo"
            />
          </Grid>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          <Formik
            initialValues={{
              userEmail: "",
            }}
            validationSchema={Yup.object({
              userEmail: Yup.string().email("Invalid email format").required("Email is required"),
            })}
            onSubmit={handleForgotPassword}
          >
            {({ isSubmitting, handleSubmit }) => (
              <Form
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSubmit();
                  }
                }}
              >
                <MDBox mb={2}>
                  <Field
                    name="userEmail"
                    as={MDInput}
                    type="email"
                    label="Email"
                    fullWidth
                    required
                  />
                  <ErrorMessage name="userEmail" component="h6" style={{ color: "red" }} />
                </MDBox>

                <MDBox mt={4} mb={1}>
                  <MDButton
                    type="submit"
                    variant="gradient"
                    color="success"
                    fullWidth
                    disabled={isSubmitting}
                  >
                    Send Verification Code
                  </MDButton>
                </MDBox>
              </Form>
            )}
          </Formik>
        </MDBox>
      </Card>
    </BasicLayout>
  );
};

export default ForgotPassword;
